import {Routes} from '@src/Constant/routes';

const getPrefixedPattern = (routeEnum: Routes) => {
  return `/:lang?/app${routeEnum}`;
};

export default getPrefixedPattern;
